import React from "react";
import "./App.css";
import MyRouter from "./components/Router";

function App() {
  return (
    <div className="App">
      <MyRouter />
    </div>
  );
}

export default App;
